import React from 'react';
import Sidebar from '../learnSidebar';
import NavbarLearn from '../navbarLearn';
import useDocumentTitle from '../useDocumentTitle'

export default function Two() {
    useDocumentTitle("Chapter 2 | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">02</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">STRATEGY GUIDE</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">PLAN BEFORE YOU EXECUTE</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">CHAPTER OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Learn about the strategic element of an FRC game</p>
                        <p class="font-productsans text-base text-black mt-5">FRC is a surprisingly tactical and thought-out game. Most of the time, your strategy going into the season can determine how well you do. Check out the topics below:</p>
                        <a href="/learn/two">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 2</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">STRATEGY GUIDE</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/two/a">Key Tenets of FRC Strategy</a>
                                    <p class="font-productsans font-normal ml-3">Basics of FRC game strategy that every member should know.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/two/b">Past Game Analysis</a>
                                    <p class="font-productsans font-normal ml-3">Example analysis of previous games and a general guide for how you or your team should go about doing it.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}